import { toggleSingleSceneObject } from "../../togglers";
import { OFFSET_GAZZLIFT, OFFSET_GLIDERS } from "./pos_map";
import { updateGazliftDependencies } from "./updateGazliftDependencies";

export const changeGazlift = (isChecked, type) => {
    const name = `stul__sta__gazlift_${type}`;

    const isOporaGlaydery = servObj.activeOpora.some((opora) => opora.userData.type === "glaydery");
    const position = isOporaGlaydery ? { y: 10 - OFFSET_GLIDERS.Y } : { y: 10 };

    toggleSingleSceneObject({
        allObjects: servObj.allGazlifts,
        activeArray: servObj.activeGazlifts,
        name,
        isChecked,
        position,
        userData: { name, type },
    });

    // Смещаем стул по Y, если добавляем высокий газлифт, иначе возвращаем на 0
    servObj.redactorModeObject.children.forEach((child) => {
        let resY = type === "visokiy" ? OFFSET_GAZZLIFT.Y : 0;
        if (isOporaGlaydery) {
            resY -= OFFSET_GLIDERS.Y;
        }
        child.position.y = resY;
    });

    // Вызываем функцию зависимостей газлифта
    updateGazliftDependencies();
};
